import React, { useContext } from "react";
import { Avatar, Tooltip } from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import {
  resolveUserAvatar,
  resolveMessageOperatorUser,
  handleImageErrorSilent,
} from "../../utils/avatar";

const MessageOperatorAvatar = ({ message, companyId, size = 28, className }) => {
  const { user: currentUser } = useContext(AuthContext);

  if (!message?.fromMe) return null;

  const operator = resolveMessageOperatorUser(message, currentUser);
  if (!operator) return null;

  const label = operator.name || "Atendente";
  const src = resolveUserAvatar(operator, companyId);
  const avatarSrc = src !== "/nopicture.png" ? src : undefined;

  return (
    <Tooltip title={label} placement="left">
      <Avatar
        key={avatarSrc || `initial-${label}`}
        className={className}
        src={avatarSrc}
        alt={label}
        imgProps={{ onError: handleImageErrorSilent }}
        style={{
          width: size,
          height: size,
          fontSize: size * 0.42,
          flexShrink: 0,
        }}
      >
        {label.charAt(0).toUpperCase()}
      </Avatar>
    </Tooltip>
  );
};

export default MessageOperatorAvatar;
